import React from 'react';
import { ApolloProvider } from 'react-apollo';
import { hot } from 'react-hot-loader';
import apolloClient from './graphql/apolloClient';
import App from './App';
import './less/antd.less';
import './scss/global.scss';

const Root = () => (
  <ApolloProvider client={apolloClient}>
    <App />
  </ApolloProvider>
);

export default hot(module)(Root);



// WEBPACK FOOTER //
// ./src/Root.jsx